

export class StateOutputWithStatus implements IStateOutputWithStatus {
    /** The auto-generated id of the state master */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    /** Manage status of state. 0 For De-active, 1 For Active */
    status!: number;
    /** Total number of city which is in perticular state */
    total_city!: number;

    constructor(data?: IStateOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
            this.status = _data["status"];
            this.total_city = _data["total_city"];
        }
    }

    static fromJS(data: any): StateOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StateOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        data["status"] = this.status;
        data["total_city"] = this.total_city;
        return data; 
    }
}

export interface IStateOutputWithStatus {
    /** The auto-generated id of the state master */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
    /** Manage status of state. 0 For De-active, 1 For Active */
    status: number;
    /** Total number of city which is in perticular state */
    total_city: number;
}

